import { render, staticRenderFns } from "./ed-popup-menu.component.vue?vue&type=template&id=0a086af2&scoped=true&"
import script from "./ed-popup-menu.component.ts?vue&type=script&lang=ts&"
export * from "./ed-popup-menu.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-popup-menu.component.scss?vue&type=style&index=0&id=0a086af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a086af2",
  null
  
)

export default component.exports